<ng-container *resolution="'desktop'">
  <h3 mat-dialog-title>
    <ng-container *ngTemplateOutlet="title"></ng-container>
  </h3>
  <div mat-dialog-content>
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </div>
  <div mat-dialog-actions class="flex items-center justify-between">
    <ng-container *ngTemplateOutlet="logoutBtn"></ng-container>
  </div>
</ng-container>

<div class="inner-content filter-dialog" *resolution="'mobile'">
  <ion-header class="ion-no-border modal-title">
    <div class="modal-handle"></div>
    <ion-toolbar mode="ios">
      <ion-title>
        <ng-container *ngTemplateOutlet="title"></ng-container>
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="content p-20">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </div>
  <ion-footer class="ion-padding">
    <ion-toolbar mode="ios">
      <ng-container *ngTemplateOutlet="logoutBtn"></ng-container>
    </ion-toolbar>
  </ion-footer>
</div>

<ng-template #text>
  <p class="new-version-site-available-text">A new version of the site is available. Please reload the page to get the latest version.</p>
</ng-template>

<ng-template #title> New version available </ng-template>

<ng-template #logoutBtn>
  <button mat-raised-button class="medium w-120 ml-auto" mat-raised-button color="primary" (click)="reload()">Reload</button>
</ng-template>
